import React, { useEffect, useState } from 'react';
// import congratulations from "../../../assets/thanks.jpg";
import congratulationsMobile from "../../assets-crm/thank-mob.jpg";
// import congratulations from '../../assets-crm/thanks.jpg';


import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { useSelector, useDispatch } from 'react-redux';
import { updateCustomerDetails, updateJourneyEvents, customerDetailsApiCall } from '../../../CustomerJourneyDetails/CustomerJourneyDetails';
import MobileNav from '../../component/MobileNav';


function ThankYou() {

  // const [bgImage, setBgImage] = useState(congratulations);
  const customerStep = useSelector((state) => state?.customerJourneyDetails?.journeySteps);
  const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
  const dispatch = useDispatch();

  const params = {
    profileId: customerDetails?.profileId,
    profile_id: customerDetails?.profileId,
  };



  async function fetchCustomerDetails() {
    if (params.profileId) {
      let { payload } = await dispatch(customerDetailsApiCall(params));
      // alert(JSON.stringify(payload));
      if (payload?.Data?.Status == 1) {
        dispatch(updateCustomerDetails(payload?.Data?.customer_details));
        dispatch(updateJourneyEvents(payload?.Data?.screen_details));

      }
    }
  }



  useEffect(() => {
    fetchCustomerDetails();

  }, [customerStep?.check_eligibility]);


  // useEffect(() => {

  //   const handleResize = () => {
  //     if (window.innerWidth <= 768) {
  //       setBgImage(congratulationsMobile);
  //     } else {
  //       setBgImage(congratulations);
  //     }
  //   };

  //   handleResize(); 
  //   window.addEventListener('resize', handleResize);

  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);


  return (
    <div>
      {/* <BoxWrapper className="w100 gray"> */}
      <div
        className="bg-thanks">
        <div className="thanks-left text-center">
          <div className='thanksmobile'>
            <img src={congratulationsMobile} alt='Thank you for showing interest' />
          </div>
          <h1 className='fw-bold fs-2'>Thank you for showing interest in <span style={{ color: '#1973be' }}>Udhaarpaisa </span></h1>
          <h6 className='pt-4'>We have received your loan application.
            <br /> <br />
            If your have any query feel free to connect with us. 
            <div className='pt-4 fw-semibold fs-5 text-center'>
              <div><MailOutlineOutlinedIcon style={{ color: '#9a141a' }} /> info@Udhaarpaisa.in  &nbsp; </div>
              <div className='pt-3'> <CallOutlinedIcon style={{ color: '#9a141a' }} />
                <Link to='https://wa.me/8368174368' target='_blank' style={{ textDecoration: 'none', color: '#000' }}> +91: 83681-74368</Link>
              </div>
            </div>
          </h6>

          <Button variant="outlined" className='icon-color-primary mt-4 fs-5' style={{ background: '#9a141a', color: '#fff', padding: '30px 15px' }} startIcon={<LibraryAddCheckIcon />}>
            <Link to='/journey/dashboard' className='text-decoration-none icon-color-primary text-white fw-bold'  > Go to Dashboard </Link>
          </Button>
        </div>
      </div>
      <MobileNav/>

      {/* </BoxWrapper> */}
    </div>
  );
}

export default ThankYou;
